import fieldCreatedProjections from './projection/field-created.projection';
import fieldDeletedProjections from './projection/field-deleted.projection';
import fieldUpdatedProjections from './projection/field-updated.projection';
import fieldPutProjections from './projection/field-put.projection';
import fieldArchivedProjections from './projection/field-archived.projection';
const projections = {
    ...fieldCreatedProjections,
    ...fieldDeletedProjections,
    ...fieldUpdatedProjections,
    ...fieldPutProjections,
    ...fieldArchivedProjections,
};
export default projections;
//# sourceMappingURL=projections-index.js.map